import { match as integer } from "../../../src/params/integer.ts";

export const matchers = { integer };